import { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const UnifiedHelpWidget = lazy(() =>
  import('@/components/help/UnifiedHelpWidget').then((m) => ({ default: m.UnifiedHelpWidget }))
);

/**
 * PHCHelpMount — brings the unified help bubble ("This page" + AI Assistant)
 * to the PHC portal. PHC pages render their own branded shells and skip
 * Layout (where the widget normally mounts), so without this they have no
 * help bubble at all. Renders only on /phc/* routes for signed-in users.
 */
export function PHCHelpMount() {
  const { pathname } = useLocation();
  const { user } = useAuth();

  // '/phc' or '/phc/...' only — a bare startsWith('/phc') would also match
  // '/phc-academy' etc., which render inside Layout and already have the widget.
  const isPhcRoute = pathname === '/phc' || pathname.startsWith('/phc/');
  if (!user || !isPhcRoute) return null;

  return (
    <Suspense fallback={null}>
      <UnifiedHelpWidget />
    </Suspense>
  );
}
